// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageHeader from 'components/PageHeader/PageHeader'
import HomeImageLinks from 'components/PageHeader/HomeImageLinks'
import Footer from 'components/footer/footer'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

// Redux:
import { getPageData } from 'actions/page'

class HomeLayout extends React.Component {
	componentDidMount() {
		this.props.getPost( 'home', 'page' )

		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0
	}

	componentDidUpdate() {
		document.title = siteData.site_name
	}

	render() {
		const { location, match } = this.props

		return (
			<div>
				<PageHeader match={ match } location={ location } />

				<div className="main-inner">
					<div className="wide-sections">
						<section className="home-image-links">
							<HomeImageLinks />
						</section>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber ) => {
			dispatch( getPageData( slug, type, archivePageNumber ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( HomeLayout )



// WEBPACK FOOTER //
// ./layouts/HomeLayout.jsx